import React from 'react'

export default function NetworkSeedRightPane(): React.JSX.Element {
    return <div>NetworkSeedRightPane</div>
}
